<template>
    <div class="modal-card">
        <header class="modal-card-head has-bg-danger">
            <p class="modal-card-title">{{$t('MODALCOPIARDE.COPIARDE')}}</p>
        </header>
        <section class="modal-card-body is-paddingless">
            <div class="panel">
                <p class="panel-block">
                    <b-field :label="$t('MODALCOPIARDE.NIVEISDEACESSO')">
                    </b-field>
                </p>
                <div class="panel-block">
                    <b-select expanded v-model="nivelDeAcessoSelecionado">
                        <option v-for="(regra,index) in listaNiveisDeAcesso" :key="index"
                                :value="regra.regras">
                            {{ regra.nome }}
                        </option>
                    </b-select>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                      @click="confirmarCopia">{{$t('MODALCOPIARDE.COPIAR')}}</b-button>
            <b-button @click="$emit('close')">{{$t('SISTEMA.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    import { mapState } from 'vuex'   

    export default {
        data() {
            return {
                listaNiveisDeAcesso: [],
                nivelDeAcessoSelecionado: null,
            }
        },
        computed: {
            ...mapState([
                'unidadeId'
            ]),
        },
        mounted() {
            this.loadListaNiveisDeAcesso()
        },
        methods: {
            loadListaNiveisDeAcesso() {
                this.$http.get('/api/search/ListarNiveisAcesso?unidadeId='+this.unidadeId)
                    .then(res => {
                        this.listaNiveisDeAcesso = res.data
                    })
            },
            async confirmarCopia() {
                if(this.nivelDeAcessoSelecionado){
                    this.$emit('copiarNivelDeAcesso', this.nivelDeAcessoSelecionado)
                    this.$emit('close')
                }
            },
        }
    }
</script>